import React from "react"
import { MainContainer } from "./styles/container"

export default function Container({ children, ...rest }) {
  return <MainContainer {...rest}>{children}</MainContainer>
}
